import styled from 'styled-components'

export const ProfileContainer = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px 24px;

  .row {
    display: flex;
    width: 100%;
    align-items: stretch;
    gap: 52px;

    &.info {
      div {
        width: fit-content;
        text-align: left;
      }
    }
  }

  .active-activity {
    color: #0a0a18;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.12px;
    border-radius: 10px;
    background: #f8f8f8;
    border: 1px solid #f8f8f8;
    text-decoration: none;
    padding: 10px 20px;
    gap: 3px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    border: 1px solid #08a8d2;
    background: #bdddeb;
    &:hover,
    &:focus {
      border: 1px solid #08a8d2;
      background: #bdddeb;
    }
  }
  .buttons {
    display: flex;
    flex-direction: row;
    gap: 8px;

    .active {
      border: 0.5px solid #08a8d2;
      background: #bdddeb;
    }
  }

  .dropbox-link {
    text-align: left;
    border-radius: 10px;
    background-color: #f6f6f6;
    padding: 8px 12px;
    max-width: 317px;

    a {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: -0.24px;
      text-decoration-line: underline;
    }
  }

  .change-credentials-button {
    border: 1px solid #08a8d2;
    padding: 15px 25px;
    font-weight: 500;
  }

  .save-profile-button {
    font-size: 16px;
    padding: 12px 25px;
    height: auto;
  }

  @media screen and (max-width: 768px) {
    padding: 8px 10px;
  }
`

export const RowInformation = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 20px;

  @media screen and (max-width: 768px) {
    gap: 10px;
    flex-direction: column;
    div {
      width: 100%;
    }
  }
`

export const ImageContainer = styled.div`
  /* width: 190px; */
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  max-width: 225px;

  @media screen and (max-width: 768px) {
    height: 190px;
  }
`

export const InputsContainer = styled.div`
  width: calc(100% - 300px);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  text-align: left;
  column-gap: 30px;

  .col {
    /* padding-top: 10px; */

    &.col-md {
      width: calc(50% - 20px);
      flex: auto;

      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }

    &.col-xl {
      width: 100%;
      flex: auto;
    }
  }

  .input-container {
    width: calc(50% - 20px);
    padding-top: 10px;

    .profile-input {
      color: #8e92bc;
      background: transparent;
      border: 1px solid #dbdbdb;

      &:disabled {
        color: #0a0a18;
        background: #f6f6f6;
        border: none;
      }
    }

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`

export const ProfesorsExperienceContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 32px;

  @media screen and (max-width: 768px) {
    gap: 10px;

    div {
      width: calc(50% - 5px);
      display: flex;
      flex-direction: column;

      div {
        width: 100%;
      }

      .break-line {
        padding: 0 20px;
      }
    }
  }
`

export const ChangeCredentialsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 92px;
  justify-content: flex-start;

  .col-md {
    text-align: left;
    width: calc(50% - 92px);
    flex: auto;

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`

export const ChangePasswordContainer = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;

  .content-password {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 10px;

    label {
      width: 100%;
      position: relative;
      align-items: center;
      display: flex;

      .password-button {
        position: absolute;
        right: 10px;
      }
    }
    svg {
      margin-left: 10px;
      cursor: pointer;
      width: 22px;
    }
  }

  .error {
    margin-top: 20px;
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
`

export const ChangeEmailContainer = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
`

export const FormResponsesSectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
`

export const CollapsableContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
`

export const CollapsableTitle = styled.div<{ $hasForm: boolean }>`
  display: flex;
  align-items: center;
  cursor: ${({ $hasForm }) => ($hasForm ? 'pointer' : 'default')};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px;
  border: 1px solid #08a8d2;
  background-color: #fdfdfd;
  border-radius: 10px;
  z-index: 1;

  p {
    font-size: 14px;

    svg {
      font-size: 20px;
    }
  }
`

export const CollapsableContent = styled.div<{ $isCollapsed: boolean }>`
  width: 100%;
  max-height: ${({ $isCollapsed }) => ($isCollapsed ? 'auto' : '0')};
  border: 1px solid #d3d3d3;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: hidden;
  visibility: ${({ $isCollapsed }) => ($isCollapsed ? 'visible' : 'hidden')};
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: -6px;
  z-index: 0;

  & > * {
    opacity: ${({ $isCollapsed }) => ($isCollapsed ? '1' : '0')};
    transform: translateY(
      ${({ $isCollapsed }) => ($isCollapsed ? '0' : '-20px')}
    );
    transition:
      opacity 0.2s ease-in-out,
      transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    padding: 26px 20px 20px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`

export const DoubleCol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 30px;
  text-align: left;

  .col {
    width: calc(50% - 30px);
  }
`
export const MultipleCols = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 30px;

  @media screen and (max-width: 768px) {
    gap: 10px;
    text-align: center;

    div {
      width: calc(50% - 5px);
      display: flex;
      flex-direction: column;

      div {
        width: 100%;
      }
    }
  }
`
